import isEmailLike from 'is-email-like';
import React from 'react';
import UI from '../../commons/services/UI';
import Wix from '../../commons/services/Wix';
import request from '../../commons/services/request';

const FORM_STATES = {
  DEFAULT: 'DEFAULT',
  SENDING: 'SENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

export default class SupportTab extends React.Component {
  constructor(props) {
    super(props);

    this.rateUs = this.rateUs.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.validateMessage = this.validateMessage.bind(this);
    this.send = this.send.bind(this);
    this.isFormValid = this.isFormValid.bind(this);

    this.state = {
      formState: FORM_STATES.DEFAULT,
      error: null,
      email: '',
      message: ''
    };
  }

  rateUs() {
    Wix.Settings.openReviewInfo();
  }

  setEmail(email) {
    this.setState({
      email: email
    });
  }

  setMessage(message) {
    this.setState({
      message: message
    });
  }

  send() {
    const { email, message } = this.state;

    this.setState(() => ({
      formState: FORM_STATES.SENDING
    }));

    request
      .post('/api/contact/send', {
        email,
        message
      })
      .then(response => {
        const body = response.data;

        if (body.error) {
          this.setState(() => ({
            formState: FORM_STATES.ERROR,
            error: body.error
          }));
        } else {
          this.setState(() => ({
            formState: FORM_STATES.SUCCESS
          }));
        }
      })
      .catch(() => {
        this.setState(() => ({
          formState: FORM_STATES.ERROR,
          error: 'unknown error'
        }));
      });
  }

  validateEmail(email) {
    return isEmailLike(email);
  }

  validateMessage(message) {
    return message.length > 5;
  }

  isFormValid() {
    return this.messageRef &&
      this.messageRef.isValueValid() &&
      (this.emailRef && this.emailRef.isValueValid());
  }

  render() {
    const { formState, error } = this.state;
    let form;

    if (formState === FORM_STATES.SUCCESS) {
      form = (
        <p className="SupportTab__SuccessParagraph">
          Thanks for your message. Our support team will get in contact with you soon.
        </p>
      );
    } else if (formState === FORM_STATES.ERROR) {
      form = (
        <p className="SupportTab__ErrorParagraph">
          Error: {error}
        </p>
      );
    } else {
      form = (
        <div>
          <UI.textInput
            title="What's your email?"
            ref={emailRef => this.emailRef = emailRef}
            placeholder="Email"
            validator={this.validateEmail}
            invalidMessage="Invalid email address!"
            validateOnBlurOnly={true}
            onBlur={() => {
              this.forceUpdate();
            }}
            onChange={this.setEmail}
          />

          <hr className="divider-short" />

          <UI.textInput
            title="What do you want to tell us?"
            ref={messageRef => this.messageRef = messageRef}
            placeholder="Write us your message (new feature idea / other issues)"
            isMultiLine={true}
            invalidMessage="Message must be at least 5 characters long"
            validator={this.validateMessage}
            validateOnBlurOnly={true}
            onKeyDown={() => {
              this.forceUpdate();
            }}
            onChange={this.setMessage}
          />

          <hr className="divider-short" />

          <div className="button-wrapper-center">
            <UI.button
              label="Send"
              disabled={
                !this.isFormValid() || formState === FORM_STATES.SENDING
              }
              onClick={this.send}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="SupportTab">
        <hr className="divider-long" />
        <UI.sectionDividerLabeled label="Developer info" />
        <hr className="divider-long" />

        <ul className="SupportTab__DeveloperInfo">
          <li>
            <UI.symbol name="email" />
            {' '}
            <a href="mailto:support@sope.io">support@sope.io</a>
          </li>
          <li>
            <UI.symbol name="globe" />
            {' '}
            <a
              href="https://sope.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Developer Website{' '}
            </a>
            {' '}
          </li>
        </ul>

        <hr className="divider-long" />
        <UI.sectionDividerLabeled label="Review the App" />
        <hr className="divider-long" />

        <p className="SupportTab__ReviewParagraph">
          Enjoying Open Sign? Leave us a review in the App Market.
        </p>
        <div className="button-wrapper-center">
          <UI.button
            className="btn-confirm-primary"
            label="Rate Us"
            onClick={this.rateUs}
          />
        </div>

        <hr className="divider-long" />
        <UI.sectionDividerLabeled label="Send us a message" />
        <hr className="divider-long" />
        {form}
        <div style={{ height: '200px' }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/apps/settings/SupportTab.jsx